const UPDATE_ROUGE_EXCLUSIVE_REWARDS = 'UPDATE_ROUGE_EXCLUSIVE_REWARDS';

export { UPDATE_ROUGE_EXCLUSIVE_REWARDS };
